var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 341",
    d: "M31.114 25.2a13.1 13.1 0 0 0 2.245.2 12.7 12.7 0 1 0-11.72-17.6 4.1 4.1 0 0 0-7.339 3.563 12.99 12.99 0 0 0-9.1 12.37v7.352a1.044 1.044 0 0 1-1.042 1.044 4.157 4.157 0 1 0 0 8.314h9.709a4.626 4.626 0 0 0-.146 1.117 4.441 4.441 0 1 0 8.881.133v-.133a4.094 4.094 0 0 0-.146-1.117h9.705a4.157 4.157 0 0 0 0-8.314 1.043 1.043 0 0 1-1.044-1.042V25.2zM34.7 6.728v8.459a1.354 1.354 0 0 1-2.708 0V6.728a1.354 1.354 0 0 1 2.708 0m-1.354 11.64a1.354 1.354 0 1 1-1.354 1.354 1.354 1.354 0 0 1 1.354-1.354M18.219 8.282a1.74 1.74 0 0 1 1.7 1.7 1.685 1.685 0 0 1-.247.888 13.542 13.542 0 0 0-2.985 0 1.685 1.685 0 0 1-.247-.888 1.74 1.74 0 0 1 1.781-1.7m-.041 35.365a2.074 2.074 0 0 1-1.749-3.2h3.488a2.074 2.074 0 0 1-1.739 3.2m14-9.156a1.8 1.8 0 0 1 0 3.589H4.169a1.8 1.8 0 0 1 0-3.589 3.411 3.411 0 0 0 3.406-3.406v-7.353a10.605 10.605 0 0 1 10.594-10.593 10.253 10.253 0 0 1 2.509.3 12.717 12.717 0 0 0 8.085 11.1v6.547a3.425 3.425 0 0 0 3.414 3.405",
    transform: "translate(1 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotice);
export default __webpack_public_path__ + "static/media/ic_notice.5f36ef898310b4de6d63ac29d1fc407c.svg";
export { ForwardRef as ReactComponent };